import script from "./Interval.vue?vue&type=script&lang=ts"
export * from "./Interval.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__